import { Card, CardHeader, Typography, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../../app/slices/subcategorySlice";
import SubCategoriesForm from "../../form";
import { TbSubtask } from "react-icons/tb";
import Permission from "../../../../../components/userPermission/userPermission";


const SubCategoriesHeader = () => {
  const subCategories = useSelector((state) => state.subCategories);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            الفئات الثانوية
          </Typography>
        }
        avatar={<TbSubtask size={20} />}
        action={
          <Permission permission="sub_category_edit">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة فئة ثانوية
            </Button>
          </Permission>
        }
      />
      {subCategories.subCategory.dialog ? <SubCategoriesForm /> : null}
    </Card>
  );
};

export default SubCategoriesHeader;
